import { useMutation } from 'react-query';

import { billingErrorToast } from '@components/BillingError/toast';
import { trackNewUser } from '@tracking';
import {
  CreateUserForSubscribePageParams,
  createUserForSubscribePage,
} from '@utils/backend-api/users';
import { BillingErrorPayload, normalizeBillingError } from '@utils/billingErrors';

const useUserCreateForSubscribePage = () => {
  const { mutate, mutateAsync, isLoading, isError } = useMutation(
    (params: CreateUserForSubscribePageParams) => createUserForSubscribePage(params),
    {
      onError: (
        error: Partial<BillingErrorPayload> & { message?: string; redirect_to?: string }
      ) => {
        billingErrorToast(normalizeBillingError(error));
        if (error.redirect_to) {
          window.location.href = error.redirect_to;
        }
      },
      onSuccess: (response) => {
        if (response.isNewUser) {
          trackNewUser(response.email, response.leadType, {});
        }
        if (response.redirectTo) {
          window.location.href = response.redirectTo;
        }
      },
    }
  );
  return { mutate, mutateAsync, isLoading, isError };
};

export default useUserCreateForSubscribePage;
